var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "mobile-page" }, [
        _vm.listStyle === 0
          ? _c("div", { staticClass: "member-coupon", style: _vm.boxStyle }, [
              _c(
                "div",
                { staticClass: "header acea-row row-between-wrapper" },
                [
                  _c("div", { staticClass: "title", style: _vm.titleColor }, [
                    _vm._v(" " + _vm._s(_vm.configObj.titleConfig.val) + " "),
                  ]),
                  _c("div", { staticClass: "more", style: _vm.moreColor }, [
                    _vm._v("更多"),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "coupon-list" },
                _vm._l(_vm.couponList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "coupon-item acea-row row-between-wrapper",
                      style: _vm.couponListStyle,
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "left-content",
                          style: { color: _vm.priceColorStyle },
                        },
                        [
                          _c("div", { staticClass: "price" }, [
                            _c("span", { staticClass: "symbol" }, [
                              _vm._v("¥"),
                            ]),
                            _c("span", { staticClass: "num" }, [
                              _vm._v(_vm._s(item.money)),
                            ]),
                          ]),
                          _c("div", { staticClass: "condition" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.minPrice > 0
                                    ? "满" + item.minPrice + "可用"
                                    : "无门槛"
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "middle-content" }, [
                        _c(
                          "div",
                          { staticClass: "scope line1", style: _vm.scopeColor },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        ),
                        item.day
                          ? _c(
                              "div",
                              {
                                staticClass: "time",
                                style: {
                                  color:
                                    _vm.configObj.deadlineColor.color[0].item,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s("领取后" + item.day + "天内可用") +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "time",
                                style: {
                                  color:
                                    _vm.configObj.deadlineColor.color[0].item,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.useStartTime +
                                        " - " +
                                        item.useEndTime
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "right-btn text-center",
                          style: _vm.btnColorStyle,
                        },
                        [_vm._v("去使用")]
                      ),
                    ]
                  )
                }),
                0
              ),
            ])
          : _c("div", { staticClass: "member-coupon", style: _vm.boxStyle }, [
              _c(
                "div",
                { staticClass: "header acea-row row-between-wrapper" },
                [
                  _c("div", { staticClass: "title", style: _vm.titleColor }, [
                    _vm._v(" " + _vm._s(_vm.configObj.titleConfig.val) + " "),
                  ]),
                  _c("div", { staticClass: "more", style: _vm.moreColor }, [
                    _vm._v("更多"),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "coupon-scroll-list" },
                _vm._l(_vm.couponList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "coupon-card",
                      style: [
                        { marginRight: _vm.contentConfig },
                        {
                          backgroundColor: _vm.themeStyle
                            ? _vm.couponBgColor
                            : _vm.themeRgba,
                        },
                        { borderColor: _vm.priceColorStyle },
                        {
                          borderRadius: _vm.configObj.contentStyle.val
                            ? _vm.configObj.contentStyle.val + "px"
                            : "0",
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tag",
                          style: {
                            backgroundColor: _vm.themeStyle
                              ? _vm.labelColor
                              : _vm.lightColor,
                            color: _vm.priceColorStyle,
                            borderTopLeftRadius:
                              _vm.configObj.contentStyle.val + "px",
                          },
                        },
                        [_vm._v(" 会员专享 ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "left-box",
                          style: { color: _vm.priceColorStyle },
                        },
                        [
                          _c("div", { staticClass: "price" }, [
                            _c("span", { staticClass: "symbol" }, [
                              _vm._v("¥"),
                            ]),
                            _c("span", { staticClass: "num" }, [
                              _vm._v(_vm._s(item.money)),
                            ]),
                          ]),
                        ]
                      ),
                      _c("div", {
                        staticClass: "split-line-vertical",
                        style: { borderLeftColor: _vm.lightColor },
                      }),
                      _c("div", { staticClass: "right-box" }, [
                        _c(
                          "div",
                          {
                            staticClass: "condition",
                            style: { color: _vm.priceColorStyle },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.minPrice > 0
                                    ? "满" + item.minPrice + "可用"
                                    : "无门槛"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "scope", style: _vm.scopeColor },
                          [
                            _vm._v(
                              "-" +
                                _vm._s(
                                  item.category === 1 ? "商家券" : "商品券"
                                ) +
                                "-"
                            ),
                          ]
                        ),
                      ]),
                      _c("div", {
                        staticClass: "decoration left",
                        style: { background: _vm.bgColor },
                      }),
                      _c("div", {
                        staticClass: "decoration right",
                        style: { background: _vm.bgColor },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }